module.exports = __webpack_public_path__ + "static/media/pie.ada24050.svg";